<div class="modal fade" id="activity-log" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title w-100 text-center">Activity log</h6>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">Activity logs</div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          tooltip="Close"
          id="closeaddadmin"
          data-bs-dismiss="modal"
          #closemodel
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
